const PHRASES = [
  "Respond faster",
  "Follow up properly",
  "Re-engage quiet enquiries",
  "Book more consultations",
  "Support your front desk",
];

export default function Marquee() {
  const row = [...PHRASES, ...PHRASES, ...PHRASES, ...PHRASES];
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-ink/10 py-7"
      aria-hidden="true"
    >
      <div className="marquee-track flex w-max items-center gap-12 whitespace-nowrap">
        {row.map((p, i) => (
          <span key={i} className="flex items-center gap-12">
            <span className="font-display text-2xl italic tracking-wide text-ink/35 md:text-3xl">
              {p}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-teal/50" />
          </span>
        ))}
      </div>
    </div>
  );
}
